import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Line } from 'rc-progress';
import { Notification, SpinnerModal, Stack, Box, Heading, Text, Icons, Button } from 'sarsaparilla';
import { getSaveStatus } from "../../reducers/saveStatus";

export const SaveStatus = ({ onClose }) => {
    const status = useSelector((state) => getSaveStatus(state));

    const { total, complete, errors } = status;

    const isLoading = total > 0;
    const hasError = errors.length > 0;
    const isSuccessful = total === 0 && errors.length === 0;

    useEffect(() => {
        if (isSuccessful) {
            setTimeout(() => {
                onClose({ shouldRedirect: true })
            }, 5000);
        }
    }, [status, onClose, isSuccessful])

    return (
        <SpinnerModal
            isOpen
            isSpinning={isLoading}>
            <Stack>
                { hasError && (
                    <Notification type="error">
                        <div className="rec-notification-title">Problems while saving:</div>
                        <ul>
                            { errors.map((error, i) => (
                                <li key={`${error.description}-${i}`}>{error.description}</li>
                            ))}
                        </ul>
                        <Button
                            appearance="link"
                            onClick={() => onClose({ shouldRedirect: false })}>
                            Close
                        </Button>
                    </Notification>
                )}
                
                { isSuccessful && (
                    <Notification title="Update Successful" type="success">
                        Page would redirect in 5 seconds...&nbsp;
                        <Button
                            appearance="link"
                            onClick={() => onClose({ shouldRedirect: true })}>
                            Go Back
                        </Button>
                    </Notification>
                )}

                { isLoading && (
                    <>
                        <Box alignX="center" style={{ color: '#b3532d' }}>
                            <Icons.IconWarning size="lg" />
                        </Box>
                        
                        <Heading
                            headingLevel={1}
                            appearance="h5"
                            style={{ textAlign: 'center' }}>
                            Synching Changes
                        </Heading>

                        <Text style={{ textAlign: 'center' }}>
                            Please wait
                        </Text>

                        <Line
                            percent={100.0 * complete / total}
                            trailWidth="3"
                            strokeWidth="3" />

                        <Text style={{ textAlign: 'center' }} fontWeight="bold">
                            Do not reload or refresh browser
                        </Text>
                    </>
                )}
            </Stack>
        </SpinnerModal>
    );
}

SaveStatus.propTypes = {
    status: PropTypes.shape({
        total: PropTypes.number,
        complete: PropTypes.number,
        errors: PropTypes.arrayOf(PropTypes.shape({
            description: PropTypes.string
        }))
    }),
    onClose: PropTypes.func
};

export default SaveStatus;
